import { render, staticRenderFns } from "./SmartFormFormio.vue?vue&type=template&id=2bd52be8"
import script from "./SmartFormFormio.vue?vue&type=script&lang=js"
export * from "./SmartFormFormio.vue?vue&type=script&lang=js"
import style0 from "./SmartFormFormio.vue?vue&type=style&index=0&id=2bd52be8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports